import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false,
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-2xl shadow-sm border border-stone-100 overflow-hidden ${className}`} {...props} data-id="element-146">
      <div className={noPadding ? '' : 'p-6 md:p-8'} data-id="element-147">{children}</div>
    </div>;
}